import React from 'react';
import styles from '../styles/sign-up-tab.module.scss';

const Chevrons = () => {
  return (
    <svg className={styles.chevrons} viewBox="0 0 350 315.001">
      <g data-name="Group 5">
        <g
          data-name="Group 4"
          transform="translate(-1090 -730) translate(-1.982 -.401)"
        >
          <path
            data-name="Rectangle 12"
            transform="translate(1091.982 730.401)"
            className="fill-artillery-red"
            d="M0 0H350V157.501H0z"
          />
          <path
            data-name="Path 13"
            d="M2013.157 926.43l87.5-87.5 87.5 87.5 87.5-87.5v-70l-87.5 87.5-87.5-87.5-87.5 87.5-87.5-87.5v70z"
            transform="translate(-833.675 -38.528)"
            className="fill-navy-blue"
          />
        </g>
        <g
          data-name="Group 3"
          transform="translate(-1090 -730) translate(-1.982 -.901)"
        >
          <path
            data-name="Rectangle 13"
            transform="translate(1091.982 888.401)"
            className="fill-navy-blue"
            d="M0 0H350V157.501H0z"
          />
          <path
            data-name="Path 14"
            d="M2678.123 926.43l87.5-87.5 87.5 87.5 87.5-87.5v-70l-87.5 87.5-87.5-87.5-87.5 87.5-87.5-87.5v70z"
            transform="translate(-1498.64 119.472)"
            className="fill-thames-blue"
          />
        </g>
      </g>
    </svg>
  );
}

const SignUpTab = ({ handleClick }) => {
  return (
    <div onClick={handleClick} className={styles.tab}>
      Keep in touch <Chevrons />
    </div>
  )
}

export default SignUpTab;